import { render, staticRenderFns } from "./CitaInfo.vue?vue&type=template&id=ca3a8484"
import script from "./CitaInfo.vue?vue&type=script&lang=js"
export * from "./CitaInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports